<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
</svg>
